var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "pop-dialog pop-audit-record",
      attrs: {
        title: "客服订单审核流程",
        visible: _vm.visibleDialog,
        width: "520px",
        top: "calc(50vh - 220px)",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDialog = $event
        },
      },
    },
    [
      _c("step-progress", {
        staticClass: "con",
        attrs: {
          orderObj: _vm.row,
          processFunc: _vm.dictionaries.process_func,
          type: "shenheStep",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }